import { useState, useCallback } from 'react';
import { Container, Transcription } from './styled';
import VisibilitySensor from 'react-visibility-sensor';
import { Footer } from '../../components';
import { getURLAudio, getToTextAudio } from '../../../../service/serviceChat/chatService';
import { PlayerAudio } from './PlayerAudio';
import { BsPlayFill } from 'react-icons/bs';

export function Audio(props) {


    const { message, className } = props;
    const [automaticLoading, setAutomaticLoading] = useState(true);
    const [src, setSRC] = useState(false);
    const [transcription, setTranscription] = useState(false);

    const isUserSystem = message?.user_system ? true : false;

    async function audioByUserSystem(message) {
        const url = await getURLAudio(`whatsapp-images-teste`, `${message.id}${message.extension}`);
        setSRC(url ? url : false);
        setAutomaticLoading(false);
        if (message?.body) {
            setTranscription(message?.body);
        } else {
            const transcription = await getToTextAudio(`whatsapp-images-teste`, `${message.id}.wav`);
            setTranscription(transcription ? transcription : false);
        }
    };
    async function audioByUserExternal(message) {
        const url = await getURLAudio(`whatsapp-audio`, `${message?.id_voice}.wav`);
        setSRC(url ? url : false);
        setAutomaticLoading(false);
        const transcription = await getToTextAudio(`whatsapp-audio`, `${message?.id_voice}.wav`);
        setTranscription(transcription ? transcription : false);
    };

    const searchAudio = useCallback(async (message) => {
        isUserSystem
            ? await audioByUserSystem(message)
            : await audioByUserExternal(message)
        return
    }, [isUserSystem]);
    const onSearchAudio = (isVisible) => {
        if (!isVisible || src) return;
        searchAudio(message);
    };

    const RenderPlayerAudio = () => {
        if (!src) {
            return (
                <SkeletonPlayerAudio isAnimated={false} />
            )
        }
        return (
            <PlayerAudio
                src={src}
                isUserSystem={isUserSystem}
                nameAvatar={message?.author}
                date={message?.date}
            />
        )
    };
    const RenderTranscription = () => {
        if (!transcription) {
            return (
                <SkeletonTranscription isAnimated={true} />
            )
        }
        return (
            <Transcription>
                <p>
                    {transcription.replaceAll("*", " ")}
                </p>
            </Transcription>
        )
    };

    const SkeletonPlayerAudio = ({ isAnimated }) => {
        return (
            <div className='skeletonPlayerAudio'>
                <div className='line--'>
                    {isUserSystem &&
                        <span className='skeleton--avat'>
                            <span className={`${isAnimated ? 'skeleton--avat--' : ''}`}></span>
                        </span>
                    }
                    <BsPlayFill className='icon--' />
                    <span className='skeleton--progress'>
                        <span className={`${isAnimated ? 'skeleton--progress--' : ''}`}></span>
                    </span>
                    {!isUserSystem &&
                        <span className='skeleton--avat'>
                            <span className={`${isAnimated ? 'skeleton--avat--' : ''}`}></span>
                        </span>
                    }
                </div>
            </div>
        )
    };
    const SkeletonTranscription = ({ isAnimated }) => {
        return (
            <div className={`skeletonTranscription ${isUserSystem ? 'flex-end' : ''}`}>
                <span className='skeleton--line-1'>
                    <span className={`${isAnimated ? 'skeleton--line--' : ''}`}></span>
                </span>
                <span className='skeleton--line-2'>
                    <span className={`${isAnimated ? 'skeleton--line--' : ''}`}></span>
                </span>
                <span className='skeleton--line-1'>
                    <span className={`${isAnimated ? 'skeleton--line--' : ''}`}></span>
                </span>
                <span className='skeleton--line-3'>
                    <span className={`${isAnimated ? 'skeleton--line--' : ''}`}></span>
                </span>
            </div>
        )
    };

    return (
        <Container
            className={className}
            isUserSystem={isUserSystem}
        >
            {automaticLoading
                ? <VisibilitySensor onChange={(isVisible) => { onSearchAudio(isVisible) }}>
                    <>
                        <SkeletonPlayerAudio isAnimated={true} />
                        <SkeletonTranscription isAnimated={true} />
                    </>
                </VisibilitySensor>
                : <>
                    <RenderPlayerAudio />
                    <RenderTranscription />
                </>
            }
            <div className={`footer-styled`}>
                <Footer message={message} />
            </div>
        </Container>
    )
}